<template>
    <CardShell>
        <CardHeader heading="Recent Messages" :loading="loading" route="/inbox" :seeAll="true"/>
        <Contact v-for="(thread, index) in threads" :key="index" @select="selectedIndex = index" :isSelected="selectedIndex === index" :thread="thread" />
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import CardHeader from '@/components/controls/CardHeader.vue';
import Contact from '@/components/inbox/contactsCard/Contact.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        CardShell,
        CardHeader,
        Contact
    },
    data() {
        return {
            selectedIndex: null
        };
    },
    computed: {
        ...mapState('dashboard', ['threads']),
        loading() {
            return this.threads === null;
        }
    },
    methods: {
        ...mapActions('dashboard', ['getThreads'])
    },
    created: function() {
        this.getThreads();
    }
};
</script>
